import { Route } from "react-router";
import { ProtectedRoute } from "./components";
import { AddDeal, DealsList } from "@/pages";
import React from "react";
import {
  permissionsEnergyContractFull,
  permissionsEnergyContractReadonly,
} from "@/utils";

/**
 * Route definitions for energy contract management routes.
 * Allows partners to manage energy deals and contracts.
 */
export const energyContractRoutes: React.ReactElement[] = [
  <Route
    key="energy-contract"
    path=""
    element={
      <ProtectedRoute
        element={<DealsList />}
        codes={permissionsEnergyContractReadonly}
      />
    }
  />,

  <Route
    key="add"
    path="add"
    element={
      <ProtectedRoute
        element={<AddDeal />}
        codes={permissionsEnergyContractFull}
      />
    }
  />,

  <Route
    key="edit"
    path="edit/:id"
    element={
      <ProtectedRoute
        element={<AddDeal />}
        codes={permissionsEnergyContractFull}
      />
    }
  />,
];
